import {
  DRAWER_TITLE_ID,
  DrawerTitle,
  Subhead,
  useRebrand,
} from "@growtherapy/sprout-ui";
import { MOOD_SURVEY_HEADER_TEXT } from "./lang";

export function Header() {
  const isRebrand = useRebrand();

  if (isRebrand) {
    return (
      <Subhead.Default as="h2" id={DRAWER_TITLE_ID}>
        {MOOD_SURVEY_HEADER_TEXT}
      </Subhead.Default>
    );
  }

  return <DrawerTitle>{MOOD_SURVEY_HEADER_TEXT}</DrawerTitle>;
}
